import { useCallback } from 'react'

import { useMutation, useQueryClient } from 'react-query'

import { useToast } from '@/components/ui/toast.tsx'
import { restrictedWordsService } from '@/modules/restricted-words/service/restricted-words-service.ts'
import type { RestrictedWordsSettings } from '@/modules/restricted-words/types.ts'
import { handleError } from '@/utils/error'

export function useToggleRestrictedWords() {
  const queryClient = useQueryClient()
  const toast = useToast()

  const toggleMutation = useMutation(
    (state: boolean) =>
      restrictedWordsService.toggleRestrictedWordsActivation(state),
    {
      onSuccess: ({ enabled }: RestrictedWordsSettings) => {
        toast.success(
          `${enabled ? 'Enabled' : 'Disabled'} restricted words check`,
        )
        queryClient.invalidateQueries(['restrictedWordsSettings'])
      },
      onError: (error, state) =>
        handleError(
          error,
          `Failed to ${state ? 'enable' : 'disable'} restricted words`,
        ),
    },
  )

  const toggleRestrictedWords = useCallback(
    (state: boolean) => {
      return toggleMutation.mutateAsync(state)
    },
    [toggleMutation],
  )

  return {
    toggleRestrictedWords,
    isLoading: toggleMutation.isLoading,
  }
}
